/**
 * This is a generated file, do not edit it manually
 */
import admin from '../../assets/locales/en/admin.json';
import api from '../../assets/locales/en/api.json';
import common from '../../assets/locales/en/common.json';
import components from '../../assets/locales/en/components.json';
import payee from '../../assets/locales/en/payee.json';
import shared from '../../assets/locales/en/shared.json';
import util from '../../assets/locales/en/util.json';

const resources = {
  admin,
  api,
  common,
  components,
  payee,
  shared,
  util
} as const;

export default resources;
